import { render, staticRenderFns } from "./LoteProducaoCausasMortalidadeGrafico.vue?vue&type=template&id=78b90c3a&"
import script from "./LoteProducaoCausasMortalidadeGrafico.vue?vue&type=script&lang=js&"
export * from "./LoteProducaoCausasMortalidadeGrafico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports